export var AuthType;

(function (AuthType) {
  AuthType["FINGERPRINT"] = "FINGERPRINT";
  AuthType["FACIAL_RECOGNITION"] = "FACIAL_RECOGNITION";
  AuthType["IRIS"] = "IRIS";
  AuthType["NONE"] = "NONE";
})(AuthType || (AuthType = {}));

export var AuthSecurityLevel;

(function (AuthSecurityLevel) {
  AuthSecurityLevel["NONE"] = "NONE";
  AuthSecurityLevel["SECRET"] = "SECRET";
  AuthSecurityLevel["BIOMETRIC"] = "BIOMETRIC";
})(AuthSecurityLevel || (AuthSecurityLevel = {}));